import React from "react";
import DashboardAdmin from "../components/Admin/DashboardAdmin";
import { useAuth } from "../context/AuthContext";

const Dashboard = () => {
  const { user, role } = useAuth();

  if (role === "ROLE_ADMIN") {
    return <DashboardAdmin userDetails={user} />;
  }

  return <DashboardAdmin userDetails={user} />;
};

export default Dashboard;

